import React, { useEffect, useState } from 'react';
import VaccinationChart from '../../../VaccinationChart';
import { diseaseIdToName, VaccineInfo } from '../../../../api/fetchVaccineSchedule';
import AppLoader from '../../../common/AppLoader';
import { useDispatch, useSelector } from 'react-redux';
import { getPrescription } from '../../../../store/selectors/prescriptionPad';
import {
    clearAdministeredVaccines,
    updateAdministeredVaccines,
    updateFollowup,
} from '../../../../store/actions/prescriptionPad';
import { IVaccineStatus } from '../../../../prescription-types-bundle';
import { MHCWithVaccination } from '../../../../store/types/medicalHistory';
import moment from 'moment';

const PPVaccination: React.FC<{
    vaccinationData: Partial<VaccineInfo>;
    isVaccinationDataLoading: boolean;
}> = ({ vaccinationData, isVaccinationDataLoading }) => {
    const px = useSelector(getPrescription);
    const dispatch = useDispatch();

    const onChange = (newVaccs: IVaccineStatus[], allVaccs: IVaccineStatus[]) => {
        dispatch(updateAdministeredVaccines(newVaccs, allVaccs));
    };

    const onDueFollowupSet = (vaccine: IVaccineStatus) => {
        const followUpDate = moment(vaccine.date);

        dispatch(
            updateFollowup(
                followUpDate.toISOString(),
                undefined,
                `Next Vaccination Due - ${diseaseIdToName[vaccine.diseaseId].name}: ${
                    vaccine.name
                } on ${moment(vaccine.date).format('DD/MM/YYYY')}`,
            ),
        );
    };

    const dob = moment(px?.patient.profile.personal.age?.dob);
    const ageInYears = moment().diff(dob, 'years');

    const defaultSchedule = ageInYears ? (ageInYears <= 18 ? 'plan' : 'otherVaccs') : 'plan';

    return isVaccinationDataLoading ? (
        <div className="w-full h-full flex justify-center items-center">
            <AppLoader />
        </div>
    ) : (
        <VaccinationChart
            vaccinationData={vaccinationData}
            key={Object.keys(vaccinationData).length}
            vaccinationHistory={px?.allVaccines}
            clinic_id={px?.clinic._id || ''}
            patientId={px?.patient.id}
            clearSelection={() => {
                const newVaccIds = px?.administeredVaccines?.map((newVacc) => newVacc.id) || [];
                const clearedVaccs = px?.allVaccines?.filter((vac) => !newVaccIds.includes(vac.id));
                dispatch(clearAdministeredVaccines(clearedVaccs));
            }}
            onChange={onChange}
            onDueFollowupSet={onDueFollowupSet}
            defaultSchedule={defaultSchedule}
        />
    );
};

export default PPVaccination;
